import React from "react";

const vehicles = [
  {
    id: 1,
    name: "Swift Dzire",
    image: "/images/Fleet/Swift-Dzire.jpeg",
    seats: "4+1 Seats",
    luggage: "2 Bags",
    type: "Sedan",
    desc: "Affordable sedan for airport transfers, local rides, railway station pickups and one-way outstation travel.",
  },
  {
    id: 2,
    name: "Maruti Ertiga",
    image: "/images/Fleet/Maruti-Ertiga.jpg",
    seats: "6+1 Seats",
    luggage: "3 Bags",
    type: "Family MPV",
    desc: "Comfortable MPV for family trips, airport transfers, pilgrimage tours and weekend getaways.",
  },
  {
    id: 3,
    name: "Toyota Rumion",
    image: "/images/Fleet/Toyota-Rumion.jpg",
    seats: "6+1 Seats",
    luggage: "3 Bags",
    type: "Premium MPV",
    desc: "Premium MPV offering spacious seating, smooth ride quality and comfortable long-distance journeys.",
  },
  {
    id: 4,
    name: "Kia Carens",
    image: "/images/Fleet/Kia-Carens.jpg",
    seats: "6+1 Seats",
    luggage: "4 Bags",
    type: "Luxury MPV",
    desc: "Modern premium MPV with luxurious interiors, extra comfort and generous luggage capacity.",
  },
  {
    id: 5,
    name: "Innova Cab",
    image: "/images/Fleet/Innova-Cab.jpg",
    seats: "7 Seats",
    luggage: "4 Bags",
    type: "SUV",
    desc: "Reliable SUV for airport transfers, business travel, sightseeing and outstation cab services.",
  },
  {
    id: 6,
    name: "Innova Crysta",
    image: "/images/Fleet/Innova-Crysta.jpeg",
    seats: "7 Seats",
    luggage: "5 Bags",
    type: "Premium SUV",
    desc: "Luxury chauffeur-driven SUV for executives, VIP guests and premium family travel.",
  },
  {
    id: 7,
    name: "Tempo Traveller",
    image: "/images/Fleet/Tempo-Traveller.jpg",
    seats: "12-17 Seats",
    luggage: "10 Bags",
    type: "Traveller",
    desc: "Ideal for family tours, corporate outings, school trips, weddings and pilgrimage groups.",
  },
    {
  id: 9,
  name: "13 Seater Tempo Traveller",
  image: "/images/Fleet/13.jpeg",
  seats: "13 Seats",
  luggage: "20 Bags",
  type: "Mini Bus",
  desc: "Spacious tempo traveller ideal for group tours, airport transfers, local rides, railway station pickups and outstation travel.",
},
  {
    id: 8,
    name: "Urbania Bus",
    image: "/images/Fleet/Urbania-Bus.jpg",
    seats: "13-17 Seats",
    luggage: "12 Bags",
    type: "Luxury Van",
    desc: "Premium Force Urbania with spacious seating, luxury interiors and executive group travel comfort.",
  },
  {
    id: 9,
    name: "Mini Bus",
    image: "/images/Fleet/Mini-Bus.jpg",
    seats: "20-25 Seats",
    luggage: "20 Bags",
    type: "Mini Bus",
    desc: "Perfect for corporate events, weddings, picnics, educational tours and large family groups.",
  },


{
  id: 10,
  name: "40 Seater Bus",
  image: "/images/Fleet/bus-3.jpeg",
  seats: "40 Seats",
  luggage: "20 Bags",
  type: "Mini Bus",
  desc: "Comfortable bus for large group travel, corporate trips, tours, airport transfers and long-distance outstation journeys.",
},
{
  id: 11,
  name: "49 Seater Bus",
  image: "/images/Fleet/bus.jpeg",
  seats: "49 Seats",
  luggage: "20 Bags",
  type: "Mini Bus",
  desc: "Large-capacity bus suitable for group tours, corporate travel, events, airport transfers and outstation journeys.",
},

];

const Booking = () => {
  return (
    <>
    
 <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Online Booking
        </h2>
      </div>
    </section>

      


      <section className="booking-section ">

        <div className="container">

          <div className="text-center mb-5">

           

          </div>

          {vehicles.map((car, index) => (
            <div
              key={car.id}
              className={`booking-card row align-items-center ${
                index % 2 !== 0 ? "flex-row-reverse" : ""
              }`}
            >
              <div className="col-lg-5">

                <div className="booking-image">

                  <img
                    src={car.image}
                    alt={car.name}
                    className="img-fluid"
                  />

                  <span className="vehicle-badge">
                    {car.type}
                  </span>

                </div>

              </div>

              <div className="col-lg-7">

              

                <h3>{car.name}</h3>

                {/* <p>{car.desc}</p> */}
                                <div className="booking-features">

                  <div className="feature-box">
                    <i className="fas fa-users"></i>
                    <div>
                      <small>Capacity</small>
                      <span>{car.seats}</span>
                    </div>
                  </div>

                  <div className="feature-box">
                    <i className="fas fa-suitcase"></i>
                    <div>
                      <small>Luggage</small>
                      <span>{car.luggage}</span>
                    </div>
                  </div>

                  <div className="feature-box">
                    <i className="fas fa-snowflake"></i>
                    <div>
                      <small>Facility</small>
                      <span>Air Conditioned</span>
                    </div>
                  </div>

                  <div className="feature-box">
                    <i className="fas fa-user-tie"></i>
                    <div>
                      <small>Driver</small>
                      <span>Professional Chauffeur</span>
                    </div>
                  </div>

                  <div className="feature-box">
                    <i className="fas fa-map-marked-alt"></i>
                    <div>
                      <small>Service</small>
                      <span>Local & Outstation</span>
                    </div>
                  </div>

                  <div className="feature-box">
                    <i className="fas fa-clock"></i>
                    <div>
                      <small>Availability</small>
                      <span>24×7 Service</span>
                    </div>
                  </div>

                </div>

                <div className="booking-actions">

                 <a
  href={`https://wa.me/919970007784?text=${encodeURIComponent(
    `Hello Garud Cabs Services, I want to book ${car.name}. Please share the fare and availability.`
  )}`}
  target="_blank"
  rel="noopener noreferrer"
  className="booking-btn whatsapp-btn"
>
  <i className="fab fa-whatsapp"></i>
  Book Now
</a>
                  <a
                    href="tel:+919970007784"
                    className="booking-btn call-btn"
                  >
                    <i className="fas fa-phone-alt"></i>
                    Call Now
                  </a>

                </div>

              </div>
            </div>
          ))}

          <div className="booking-bottom">

            <div className="row align-items-center">

              <div className="col-lg-8">

                <h2>
                  Need a Comfortable Ride Anywhere?
                </h2>

            <p>
  Garud Cabs Services provides reliable taxi services across Mumbai
  and Navi Mumbai, including airport transfers, outstation cabs,
  one-way and round trips, corporate travel, pilgrimage tours, family
  vacations, and premium car rentals with professional drivers at
  affordable prices.
</p>
              </div>

              <div className="col-lg-4 text-lg-end">

                <a
                  href="tel:+919970007784"
                  className="booking-main-btn"
                >
                  <i className="fas fa-phone-alt me-2"></i>
                  Book Your Cab
                </a>

              </div>

            </div>

          </div>

        </div>

      </section>

    </>
  );
};

export default Booking;